export interface ParsedSshCommand {
  destination: string | null;
  port: number | null;
  identity: string | null;
  errors: string[];
}

export function parseSshCommandArgs(args: string[]): ParsedSshCommand {
  let destination: string | null = null;
  let port: number | null = null;
  let identity: string | null = null;
  const errors: string[] = [];

  for (let index = 0; index < args.length; index += 1) {
    const token = args[index];

    if (token === '-p') {
      const next = args[index + 1];
      if (!next) {
        errors.push('Missing port value after -p.');
        break;
      }

      const parsedPort = Number.parseInt(next, 10);
      if (!Number.isFinite(parsedPort) || parsedPort <= 0) {
        errors.push(`Invalid SSH port: ${next}`);
        break;
      }

      port = parsedPort;
      index += 1;
      continue;
    }

    if (token === '-i') {
      const next = args[index + 1];
      if (!next) {
        errors.push('Missing identity value after -i.');
        break;
      }

      identity = next;
      index += 1;
      continue;
    }

    if (token.startsWith('-')) {
      errors.push(`Unsupported SSH option: ${token}`);
      continue;
    }

    if (!destination) {
      destination = token;
      continue;
    }

    errors.push(`Unexpected SSH argument: ${token}`);
  }

  if (!destination && errors.length === 0) {
    errors.push('Usage: ssh [-p port] [-i profile] user@host | host | profile-name');
  }

  return {
    destination,
    port,
    identity,
    errors,
  };
}

export function splitSshDestination(destination: string) {
  const atIndex = destination.indexOf('@');
  if (atIndex === -1) {
    return {
      username: null,
      host: destination,
    };
  }

  return {
    username: destination.slice(0, atIndex) || null,
    host: destination.slice(atIndex + 1) || '',
  };
}
